// Extending Aura theme with purple customizations
import { definePreset } from '@primeuix/themes'
import Aura from '@primeuix/themes/aura'

const KollPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#7031a113',
      100: '#f2cde1',
      200: '#e6a3c7',
      300: '#d97aaf',
      400: '#cc5196',
      500: '#662d91',
      600: '#a31f66',
      700: '#86164f',
      800: '#b02775',
      900: '#590a2b',
      950: '#261b32',
    },
  },
  components: {
    button: {
      colorScheme: {
        light: {
          root: {
            primary: {
              color: 'white',
              hoverColor: '{primary.100}',
              background: '{primary.500}',
              borderColor: '{primary.950}',
            },
          },
        },
      },
    },
  },
  fieldset: {
    colorScheme: {
      light: {
        root: {
          background: '{primary.500}',
        },
      },
    },
  },
})

export default KollPreset
